module.exports = __webpack_public_path__ + "img/icon-close.3f810892.svg";